import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const ruleSetsByIds = api(async function ruleSetsByIds(args) {
    const ids = args?.ids
    if (!ids?.length) return { items: [] }
    return query(
        gql`
            query GetRuleSetsByIds($ids: [String]) {
                ruleSetsByIds: ruleSets(ids: $ids) {
                    items {
                        id
                        name
                        description
                        justification
                        defaultAction
                        rules {
                            id
                            type
                            name
                            enabled
                            justification
                            enabled
                            combinator
                            ruleSetId
                            ruleSetName
                            conditions {
                                field
                                operator
                                value
                            }
                            action {
                                type
                                multiplier
                                costKind
                                fixedAmount
                                timeKind
                                timeValue
                                frequencyMultiplier
                            }
                        }
                    }
                }
            }
        `,
        { ids },
        { returns: "ruleSetsByIds", fetchPolicy: "network-only" }
    )
})
